// export const apiUrl = "http://localhost:3006/v1" //window.location.origin + "/v1"; //local test
export const apiUrl = `${
  process.env.NODE_ENV === "production"
    ? window.location.origin
    : "http://localhost:3006"
}/v1`
// export const LicenseInfoKey = process.env.REACT_APP_DATAGRIDPRO_KEY
export const TOKEN = "access_token"
